import React from "react"
import types from "prop-types"
import Sidebar from "shared/Sidebar"
import DeliveryStatusFilter from "./DeliveryStatusFilter"
import FormFilter from "./FormFilter"

const RecipientSidebar = ({ hiddenSidebar }) => (
  <Sidebar hiddenSidebar={hiddenSidebar}>
    <FormFilter />
    <DeliveryStatusFilter />
  </Sidebar>
)

RecipientSidebar.propTypes = {
  hiddenSidebar: types.bool.isRequired,
}

export default RecipientSidebar
